import { initialShipmentDetails } from "../../shared/constants";
import { ApiGetTrackingDetailsForSupplyChainModel, ClientInput, ShipmentDetails, ShipmentEvent, SupplyChainTrackingEvent } from "../../shared/interfaces";
import { ORDERED } from "../../shared/strings/constants";
import { dedupeEvents, eventTimeSorter } from "../eventUtils";
import { transformSupplyChainTrackingEventToShipmentEvent } from "./transformSupplyChainTrackingEventToShipmentEvent";

export function transformSupplyChainApiResponseToShipmentDetails(apiResponse: ApiGetTrackingDetailsForSupplyChainModel, clientInput: ClientInput): ShipmentDetails {
    const shipmentDetails: ShipmentDetails = Object.assign({}, initialShipmentDetails);
    const shipmentEventsClientInput = clientInput.supplyChainTrackingEvents;

    shipmentDetails.trackingId = clientInput.trackingId || clientInput.identifierValue;
    
    shipmentDetails.carrierId = clientInput.carrierId;
    
    shipmentDetails.trackingRequestId = apiResponse.trackingResponseList[0].trackingRequest.trackingRequestId;
    
    const { trackingResponse } = apiResponse.trackingResponseList[0];
    shipmentDetails.edd = Date.parse(trackingResponse.currentStatus?.estimatedDeliveryDate?.endTime.toString() || "0");
    shipmentDetails.trackingEstimates = trackingResponse.currentStatus?.trackingEstimates;

    let trackingEventList  = trackingResponse.trackingEventList;
    if(!clientInput.displayDedupeEvents) {
        trackingEventList = dedupeEvents(trackingEventList);
    } 

    const shipmentEvents : Array<ShipmentEvent> = trackingEventList.map(transformSupplyChainTrackingEventToShipmentEvent);
    shipmentEvents.sort(eventTimeSorter);
    shipmentDetails.shipmentEvents = shipmentEvents;
    shipmentDetails.currentStatus = shipmentEvents ? shipmentEvents[0].eventStatus : ORDERED;
    
    return shipmentDetails;
}
